var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"scan-code-container follow",class:_vm.isShow ? 'show' : 'hide'},[_vm._m(0)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"scan-code"},[_c('img',{attrs:{"src":"https://wemeet-1302608036.cos.ap-shanghai.myqcloud.com/WeMeet-official-website/07.png","alt":""}}),_c('div',{staticClass:"txt"},[_vm._v("关注公众号")])])
}]

export { render, staticRenderFns }